export class EmbeddedImageError extends Error {
    constructor(public message: string) {
        super(message);
    }
}
